<template>
  <Reference
    :id="departmentId"
    :value="value"
    :total-items="totalItems"
    :label="label"
    :items.sync="items"
    component-name="Department"
    placeholder="Введіть назву департаменту"
    @input="$emit('input', $event)"
    @getItems="getItems"
  />
</template>

<script>
import * as departmentsApi from "@/backend/departmentsApi.js";
import Reference from "@/components/Reference";

export default {
  components: {
    Reference,
  },
  props: {
    label: {
      type: String,
      default: "Назва департаменту",
    },
    value: {
      type: Object,
    },
  },
  data: () => ({
    items: [],
    totalItems: 0,
  }),
  computed: {
    departmentId() {
      return this.value?.id || null;
    },
  },
  methods: {
    async getItems({ currentPage, perPage, search }) {
      const { result, totalItems } = await departmentsApi.getDepartments(
        currentPage,
        perPage,
        search
      );
      this.items = [...this.items, ...result];
      this.totalItems = totalItems;
    },
  },
};
</script>
